import React from "react";
import Nav from "react-bootstrap/Nav";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import config from "../../../config";
import {vipPreviewTimers} from "../../common/utils";

const FirstLookNav = ({can_see_first_look_items, className}) => {
    const {
        must_show_navbar_message, vip_preview_duration, vip_preview_ends_at
    } = vipPreviewTimers();

    if (can_see_first_look_items) {
        if (must_show_navbar_message) {
            const vip_preview_starts_at = vip_preview_ends_at.subtract({hours: vip_preview_duration}).format('MM/DD/YY');
            return (
                <OverlayTrigger
                    rootClose={true}
                    placement={"bottom"}
                    trigger={['click', 'hover','focus']}
                    overlay={
                        <Popover id="header-menu-nav__popover">
                            <Popover.Content>
                                EXCLUSIVE | Check back on {vip_preview_starts_at} for your next VIP Preview
                            </Popover.Content>
                        </Popover>
                    }
                >
                    <Nav.Item
                        className={`${className} grey-btn header-menu-nav__menu-item--hide-1300`}
                        as="button"
                    >
                        VIP Preview
                    </Nav.Item>
                </OverlayTrigger>
            )
        }
        return (
            <Nav.Item
                as="a"
                href={config.first_look_collection}
                className={className}
            >
                VIP Preview
            </Nav.Item>
        )
    }
    return (
        <OverlayTrigger
            rootClose={true}
            placement={"bottom"}
            trigger={['click', 'hover','focus']}
            overlay={
                <Popover id="header-menu-nav__popover">
                    <Popover.Content>
                        Exclusive to Silver, Gold & Diamond Rebag Rewards Members. <a
                        href={`${config.host_rebag}/rewards/`}>Learn more</a>
                    </Popover.Content>
                </Popover>
            }
        >
            <Nav.Item
                className={`${className} grey-btn`}
                as="button"
            >
                VIP Preview
            </Nav.Item>
        </OverlayTrigger>
    )
}

export default FirstLookNav;